import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';

const TemperaturePerceived = props => {
    const { data, language, tempFormat, mainChart } = props;

    return (
        <div
            className={
                mainChart === 'vent'
                    ? 'wrapper-data-48h mc-widget-temperature-perceived last-item'
                    : 'wrapper-data-48h mc-widget-temperature-perceived'
            }
        >
            {/* Label */}
            <div className="wrapper-data-48h__labels mc-widget-temperature-perceived__labels">
                <div className="mc-widget-TemperaturePerceived__label">
                    <h3>
                        {translate(language, 'municipal48h_temp_xaf')} ({
                            tempFormat.replace(' º', 'º')
                        })
                    </h3>
                </div>
            </div>
            {/* Data */}
            <div className="wrapper-data-48h__data mc-widget-temperature-perceived__data">
                {data.map((data, index) => (
                    <span key={index}>
                        {data.valor !== null ? Math.round(data.valor) : ''}
                    </span>
                ))}
            </div>
        </div>
    );
};

TemperaturePerceived.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.string,
            valor: PropTypes.number,
        })
    ),
    language: PropTypes.string,
    tempFormat: PropTypes.string,
    mainChart: PropTypes.string,
};

export default TemperaturePerceived;



// WEBPACK FOOTER //
// ./src/partials/TemperaturePerceived.js